<template>
    <div class="player-error-container" v-if="show">
        <div class="warning-icon-container">
            <img src="../../assets/img/warning.svg">
        </div>
        <div class="player-error-label-1">
            PLAYER ERROR
        </div>
        <div class="player-error-label-2">
            {{message}}
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlayerError',
    props: {
        message: {
            type: String
        },
        show: {
            type: Boolean
        }
    }
}
</script>
